import { render, staticRenderFns } from "./SettingGlobalMarginAndPriceDialog.vue?vue&type=template&id=e700fc28&scoped=true"
import script from "./SettingGlobalMarginAndPriceDialog.vue?vue&type=script&lang=js"
export * from "./SettingGlobalMarginAndPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingGlobalMarginAndPriceDialog.vue?vue&type=style&index=0&id=e700fc28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e700fc28",
  null
  
)

export default component.exports